<template>
    <div class="footer">
        <div class="footer-logo">
            <img src="../assets/img/logo.png" class="footer-icon">
        </div>
        <div class="footer-content">
            Welcome to 91rushgames.com!
At 91rushgames.com, we're your premier destination for all things gaming! Whether you're searching for an extensive selection of online games or seeking recommendations for top-notch game applications, we've got you covered. Dive into our vast array of free online games, all conveniently downloadable to your mobile devices, be it iOS, Android, or tablets.
Our dedication to assisting you in finding the perfect games is unparalleled. With detailed game descriptions and captivating screenshots sourced directly from app stores, we aim to guide you towards unforgettable gaming experiences. Plus, our download links seamlessly connect to Google Play and Apple stores, ensuring authentic and high-quality gaming adventures.
Here at 91rushgames.com, we're on a mission to provide exhilarating and immersive gaming adventures to players worldwide. Our ultimate goal is to help you discover your favorite games and ensure every moment spent playing is extraordinary. If you can't find the games you love, don't hesitate to reach out to us, and we'll spare no effort to assist you. Contact us at support@91rushgames.com.
        </div>
        <div class="footer-bottom">
            <game-link class="link-item" :href="getUrl('terms')">Terms of Service</game-link>
            <game-link class="link-item" :href="getUrl('company')">Company</game-link>
            <game-link class="link-item" href="mailto:support@91rushgames.com">Contact Us</game-link>
            <game-link class="link-item" :href="getUrl('privacy')">Privacy Policy</game-link>
        </div>
        <div class="footer-copyright">
            Copyright © 2025 91rushgames.com. All rights reserved.
        </div>
    </div>
</template>

<script>
    import { getUrl } from '../assets/js/url'
    export default {
        name: "Footer",
        methods: {
            getUrl
        },
    };
</script>

<style lang="less" scoped>
    .footer {
        background: rgba(66, 61, 54, 1);
        padding: 32px 25px 25px;
    }

    .footer-icon {
        height: 25px;
    }

    .footer-content {
        font-size: 13px;
        font-weight: 400;
        line-height: 20px;
        color: rgba(255, 255, 255, 1);
        margin: 25px 0;
    }

    .link-item {
        font-size: 13px;
        font-weight: 500;
        margin-bottom: 5px;
        text-decoration-line: underline;
        color: rgba(159, 151, 144, 1);
    }

    .footer-copyright {
        font-size: 13px;
        font-weight: 400;
        letter-spacing: -0.5px;
        color: rgba(159, 151, 144, 1);
        margin-top: 25px;
    }
</style>